import styled from 'styled-components';

import { PriceText } from '../../price/PriceText';

export const StyledPriceText = styled(PriceText)`
   color: ${(props) => props.theme.textBody};
`;

StyledPriceText.displayName = 'StyledPriceText';
